require('./mortgageRequestMaritalStatusAndDependents.scss');
require('./mortgageRequestMaritalStatusAndDependents.override.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

//@commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { InputSafe } = require('commonsComponents/inputSafe');

// @constants
const {
    HOLDER_OPTION_ONE,
    HOLDER_OPTION_TWO,
    MAX_DEPENDENTS,
} = require('constants/mortgageRequestPreApproval').mortgageRequestPreApprovalCommons;
const { maritalStatusOptions } = require('constants/mortgageRequestPreApproval');
const { NON_NUMERIC_REGEXP } = require('constants/index');

class MortgageRequestMaritalStatusAndDependents extends React.Component {
    constructor(props) {
        super(props);

        this.handleMaritalStatus = this.handleMaritalStatus.bind(this);
        this.handleSecondMaritalStatus = this.handleSecondMaritalStatus.bind(this);
        this.handleDependents = this.handleDependents.bind(this);
    }

    handleMaritalStatus({ value }) {
        this.props.formHandlers.handleMaritalStatus(value, HOLDER_OPTION_ONE);
    }

    handleSecondMaritalStatus({ value }) {
        this.props.formHandlers.handleMaritalStatus(value, HOLDER_OPTION_TWO);
    }

    handleDependents({ target: { value, name } }) {
        const currentHolder = name === `holder-${HOLDER_OPTION_ONE}` ? HOLDER_OPTION_ONE : HOLDER_OPTION_TWO;
        const regexValue = value.replace(NON_NUMERIC_REGEXP, '').trim();
        const formattedValue = regexValue !== '' ? parseInt(regexValue) : '';
        this.props.formHandlers.handleDependents(`${formattedValue}`, currentHolder);
    }

    buildMaritalStatusOptions() {
        const options = maritalStatusOptions.options
        return Object.keys(options).map(value => {
            return { value, label: formatText(options[value]) }
        });
    }


    buildHolderOneFields(maritalStatusOptions, responsiveMobileVersion) {
        const {
            immMortgageRequest,
            validModal,
        } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const holderOneInfo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE]);
        const maritalStatus = holderOneInfo.get('maritalStatus');
        const dependents = holderOneInfo.get('dependents');
        const dependentsIsDirty = holderOneInfo.get('dependentsIsDirty');
        const valid = validModal.getIn(['fields', HOLDER_OPTION_ONE, 'valid'], true);
        const validMaritalStatus = validModal.getIn(['fields', HOLDER_OPTION_ONE, 'maritalStatus'], true) || valid;
        const noValidDependents = (dependentsIsDirty || !valid) && (dependents === '' || dependents > MAX_DEPENDENTS);
        const errorMessage = formatText('mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_peopleOnChargeVerifyTheData');
        const cssContainer = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 mortgage-request-marital-status-and-dependents__desktopVersion ';
        const cssContainerTitle = responsiveMobileVersion ? 'col-sm-12  ' : '  col-md-4 mortgage-request-marital-status-and-dependents__desktopVersionTitle mortgage-request-marital-status-and-dependents__desktopVersionTitleHeight  ';
         return (
            <div className="row">
                <div className={cssContainerTitle}  >
                    <div className="mortgage-request-marital-status-and-dependents__label"  >
                        {responsiveMobileVersion && selectedHolder === HOLDER_OPTION_ONE ? null :
                            <FormattedText value="mortgageRequestPreApprovalStepThree-firstOwner" />

                        }
                    </div>

                </div>
                <div className={cssContainer}>
                    <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>

                        <FormattedText noWrapper={true} value="mortgageRequestPreApprovalStepThree-maritalStatusLabel" />
                    </label>
                    <OKSelect
                        errorState={!validMaritalStatus}
                        onChange={this.handleMaritalStatus}
                        options={maritalStatusOptions}
                        searchable={false}
                        value={maritalStatus}
                    />

                </div>
                <div className={cssContainer}>

                    <div class="ok-select">
                        <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>

                            <FormattedText noWrapper={true} value="mortgageRequestPreApprovalStepThree-numberOfChildrenAndDependents" />
                        </label>
                    </div>

                    <InputSafe
                        autoComplete="off"
                        errorMessage={errorMessage}
                        errorState={noValidDependents}
                        name={`holder-${HOLDER_OPTION_ONE}`}
                        onChange={this.handleDependents}
                        value={dependents}
                    />

                </div>
            </div>
        );
    }


    buildHolderTwoFields(maritalStatusOptions, responsiveMobileVersion) {
        const {
            immMortgageRequest,
            validModal,

        } = this.props;
        const cssContainer = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 mortgage-request-marital-status-and-dependents__desktopVersion ';
        const cssContainerTitle = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 mortgage-request-marital-status-and-dependents__desktopVersionTitle ';
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const holderSecondInfo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO]);
        const maritalStatus = holderSecondInfo.get('maritalStatus');
        const dependents = holderSecondInfo.get('dependents');
        const valid = validModal.getIn(['fields', HOLDER_OPTION_TWO, 'valid'], true);
        const validMaritalStatus = validModal.getIn(['fields', HOLDER_OPTION_TWO, 'maritalStatus'], true) || valid;
        const noValidDependents = dependents > MAX_DEPENDENTS;
        const errorMessage = formatText('mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_peopleOnChargeVerifyTheData');

        return (
            <div className={!responsiveMobileVersion ? 'row mortgage-request-marital-status-and-dependents__margintop-15' : "row"}>

                <div className={cssContainerTitle}>

                    <div className="mortgage-request-marital-status-and-dependents__label"  >
                        {responsiveMobileVersion && selectedHolder === HOLDER_OPTION_ONE ? null :
                            <FormattedText value="mortgageRequestPreApprovalStepThree-secondOwner" />
                        }

                    </div>

                </div>
                <div className={cssContainer}>
                    {responsiveMobileVersion &&
                        <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>
                            <FormattedText noWrapper={true} value="mortgageRequestPreApprovalStepThree-maritalStatusLabel" />
                        </label>
                    }
                    <OKSelect
                        errorState={!validMaritalStatus}
                        onChange={this.handleSecondMaritalStatus}
                        options={maritalStatusOptions}
                        searchable={false}
                        value={maritalStatus}
                    />
                </div>
                <div className={cssContainer}>

                    <div class="ok-select">
                        {responsiveMobileVersion &&

                            <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>
                                <FormattedText noWrapper={true} value="mortgageRequestPreApprovalStepThree-numberOfChildrenAndDependents" />
                            </label>
                        }

                    </div>

                    <InputSafe
                        autoComplete="off"
                        errorMessage={errorMessage}
                        errorState={noValidDependents}
                        name={`holder-${HOLDER_OPTION_TWO}`}
                        onChange={this.handleDependents}
                        value={dependents}
                    />
                    <div className="mortgage-request-marital-status-and-dependents__note">
                        <FormattedText value="mortgageRequestPreApprovalStepThree-dependentsNote" />
                    </div>
                </div>
            </div>

        );
    }

    render() {
        const { immMortgageRequest, responsiveMobileVersion } = this.props;

        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const maritalStatusOptions = this.buildMaritalStatusOptions();
        const holderOneFields = this.buildHolderOneFields(maritalStatusOptions, responsiveMobileVersion);
        const holderTwoFields = selectedHolder === HOLDER_OPTION_ONE ? null : this.buildHolderTwoFields(maritalStatusOptions, responsiveMobileVersion);
        const headerTitle = formatText('mortgageRequestPreApprovalStepThree-maritalStatus');


        return (
            <div className="row mortgage-request-marital-status-and-dependents">
                <div className="col-md-11">
                    <OKBoxTitle value={headerTitle} size="medium" />
                </div>
                <div>
                    <div className='container-fluid'>
                        {holderOneFields}
                        {holderTwoFields}
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestMaritalStatusAndDependents.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    formHandlers: PropTypes.object.isRequired,
    validModal: PropTypes.object.isRequired
}

module.exports = MortgageRequestMaritalStatusAndDependents;
